import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ArchiveBrowse from './ArchiveBrowse';
import ArchiveSearch from './ArchiveSearch';
import ArchiveUpload from './ArchiveUpload';
import UnsignedReport from '../signature/UnsignedDocs';
import FileNotFound from '../FileNotFound';

class Archive extends React.Component {
  render() {
    const { config } = this.props;

    if (!config.hasArchive) {
      return <FileNotFound message="Archive support is disabled" />;
    }

    const { name } = this.props;

    switch (name) {
      case 'UPA1':
        return <ArchiveSearch />;

      case 'UPA3':
        return <ArchiveUpload />;

      case 'UPA4':
        return <ArchiveBrowse />;

      case 'UCS2':
        return <UnsignedReport />;

      default:
        return <FileNotFound message={`${name} is not yet supported`} />;
    }
  }
}

Archive.propTypes = {
  config: PropTypes.object,
  name: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    config: state.app.config,
  };
}

export default connect(mapStateToProps)(Archive);

